module.exports = __webpack_public_path__ + "img/Salary.2c3b84b3.svg";